import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { authFetch } from '../utils/authFetch';
import { servicePrintStyle } from './servicePrintStyle';
import ServiceReceptionDocument from './ServiceReceptionDocument';
import { GDPR_TEXT } from './ServiceOrderFields';

const money = v => v == null || v === '' ? '' : `${Number(v).toFixed(2)} lei`;
const choice = v => `${v === 'da' ? '☑' : '☐'} Da   ${v === 'nu' ? '☑' : '☐'} Nu`;
const box = (title, text) => <div className="print-box"><b>{title}</b><div style={{ whiteSpace: 'pre-wrap', minHeight: '16mm' }}>{text || '................................................................'}</div></div>;

export function ClientOrderDocument({ order, firma, client }) {
  const d = order.service_details || {};
  const amounts = [d.estimat_manopera, d.estimat_piese, d.estimat_tva];
  const total = amounts.every(v => v != null && v !== '') ? amounts.reduce((sum, v) => sum + Number(v), 0) : null;
  return <div className="print-a4 deviz-print service-command">
    <style>{servicePrintStyle}</style>
    <div className="print-header border-bottom pb-2 mb-3">
      <div><h4>{firma.bxdenumire}</h4><div>CUI: {firma.bxcodfiscal || '—'} · Reg. com.: {firma.bxregcom || '—'}</div>
        <div>{firma.bxadresa} {firma.bxoras}</div><div>{firma.bxtel} {firma.bxemail}</div></div>
      <div className="text-end"><h4>COMANDĂ DE REPARAȚIE</h4><b>Nr. {order.bxnumar_comanda}</b>
        <div>Data: {String(order.bxdata_comanda || '').slice(0, 10)}</div><div>{order.bxdatafin ? 'Închisă' : 'Deschisă'}</div></div>
    </div>
    <div className="grid-2 mb-3">
      <div className="print-box"><b>CLIENT / BENEFICIAR</b><div>{client?.bxdenumire || order.customer_name}</div>
        <div>{client?.bxadresa}</div><div>{client?.bxtel} {client?.bxemail}</div><div>CUI: {client?.bxcodfiscal || '—'}</div>
        <div>Reprezentant: {d.reprezentant || '........................'}</div></div>
      <div className="print-box"><b>AUTOVEHICUL</b><div>{d.marca_model || '—'} · {d.numar_auto || '—'}</div>
        <div>VIN: {order.bxsasiu || '—'}</div><div>Kilometraj: {d.km ?? '—'} km</div>
        <div>An: {d.an_fabricatie || '—'} · Motor: {d.motorizare || '—'}</div><div>Recepționer: {d.receptioner || '—'}</div></div>
    </div>
    <div className="grid-2 mb-3">{box('Solicitare inițială client — simptome și lucrări cerute', d.solicitare || order.bxdescr)}
      {box('Constatarea inițială — defecțiuni și intervenții propuse', d.constatare)}</div>
    <p><b>Termen estimat:</b> {d.termen || '................................'}</p>
    <table className="print-table mb-3"><tbody>
      <tr><td>Manoperă estimată fără TVA</td><td>{money(d.estimat_manopera)}</td></tr>
      <tr><td>Piese estimate fără TVA</td><td>{money(d.estimat_piese)}</td></tr>
      <tr><td>TVA estimată</td><td>{money(d.estimat_tva)}</td></tr>
      <tr><td><b>Total estimat cu TVA</b></td><td><b>{money(total)}</b></td></tr>
    </tbody></table>
    <div className="print-box service-signatures"><b>Declarații și acordul clientului</b>
      <p>Autorizez lucrările descrise în această comandă, la costurile și termenul consemnate. Orice lucrare suplimentară se consemnează într-o anexă și se execută numai după acordul meu scris.</p>
      <p>Returnarea pieselor înlocuite: {choice(d.returnare_piese)}</p>
      <p>Acord pentru probe de drum: {choice(d.raspuns_probe_drum || (d.probe_drum ? 'da' : ''))}</p>
      <p><b>Informare GDPR:</b> {GDPR_TEXT}<br />{choice(d.raspuns_gdpr || (d.gdpr_informat ? 'da' : ''))}</p>
      <p className="small">Confirmarea privește informarea primită, fără acord pentru marketing. Starea vehiculului și inventarul sunt consemnate în fișa de recepție atașată.</p>
      <p>Data și ora: ................................</p><div className="grid-2 mt-4"><p>Semnătură client: ................................</p><p>Semnătură service: ................................</p></div>
    </div>
    <ServiceReceptionDocument order={{ ...order, bxnumar: d.numar_auto, bxkm: d.km }} firma={firma} client={client} />
  </div>;
}

export default function ClientOrderPrint() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    let timer;
    (async () => {
      try {
        const [order, firmResult] = await Promise.all([authFetch(`/comenzi/client/${id}`), authFetch('/firma')]);
        const firma = firmResult?.items?.[0];
        if (!firma) throw new Error('Datele service-ului nu sunt disponibile.');
        const client = await authFetch(`/contacte/${order.bxcustomer_id}`);
        if (active) { setData({ order, firma, client }); timer = setTimeout(() => window.print(), 350); }
      } catch (e) { if (active) setError(e.message); }
    })();
    return () => { active = false; clearTimeout(timer); };
  }, [id]);
  return <>
    <div className="no-print p-3"><Link to={`/comenzi/client/edit/${id}`}>Înapoi la comanda clientului</Link>
      {data && <button className="btn btn-primary ms-3" onClick={() => window.print()}>Print comandă</button>}</div>
    {error ? <div className="alert alert-danger">{error}</div> : data ? <ClientOrderDocument {...data} /> : <p>Se încarcă documentul...</p>}
  </>;
}
